import { render, staticRenderFns } from "./communicationTable.vue?vue&type=template&id=be66fa96&scoped=true"
import script from "./communicationTable.vue?vue&type=script&lang=js"
export * from "./communicationTable.vue?vue&type=script&lang=js"
import style0 from "./communicationTable.vue?vue&type=style&index=0&id=be66fa96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be66fa96",
  null
  
)

export default component.exports